"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSmallPolygons = void 0;
const area_1 = __importDefault(require("@turf/area"));
const turf_1 = require("@turf/turf");
/**
 * Removes features with areas smaller than `minFeatureArea`.
 *
 * @param features Features to filter
 * @param minFeatureArea - in square metres, features smaller than this will be removed
 * @returns A feature collection with no features smaller than the minimum hole size.
 */
function removeSmallPolygons(features, minFeatureArea) {
    return (0, turf_1.featureCollection)(features.features.flatMap((feature) => {
        if (feature.geometry.type === 'Polygon') {
            if ((0, area_1.default)(feature) < minFeatureArea) {
                return [];
            }
            return [feature];
        }
        return [
            {
                ...feature,
                geometry: {
                    ...feature.geometry,
                    coordinates: feature.geometry.coordinates.filter((p) => p[0].length >= 3 && (0, area_1.default)((0, turf_1.polygon)(p)) >= minFeatureArea),
                },
            },
        ];
    }));
}
exports.removeSmallPolygons = removeSmallPolygons;
